import React from 'react';
import { selectText } from '../../util/selectText';
import { useTranslation } from 'react-i18next';

type AutoSelectTextProps = {
  title?: string;
  children: React.ReactNode;
};

const AutoSelectText = ({ title, children }: AutoSelectTextProps) => {
  const { t } = useTranslation();
  return (
    <span
      className="no-navigate monospace autoselect"
      style={{ cursor: 'copy' }}
      title={title ?? t('Click to select text')}
      onClick={(e) => {
        selectText(e.target as HTMLElement);
      }}
    >
      {children}
    </span>
  );
};
export default AutoSelectText;
